const PlaylistsLoader = () => {
    return (
        <div className="relative block group animate-pulse">
            {/* Stacked cards container */}
            <div className="relative w-full aspect-[16/9] group">
                {/* Bottom stacked cards - apply skeleton background */}
                <div className="absolute left-[7%] -top-[3%] w-[86%] h-[92%] bg-slate-800 dark:bg-pink-400/30 rounded-lg transform -translate-y-[8%] shadow-md" />
                <div className="absolute left-[3.5%] -top-[2%] w-[93%] h-[96%] bg-slate-800 dark:bg-pink-400/30 rounded-lg transform -translate-y-[4%] shadow-lg" />
                {/* Main card - apply skeleton background */}
                <div className="relative w-full h-full overflow-hidden bg-slate-700 dark:bg-pink-400/50 shadow-xl rounded-t-lg">
                    {/* Song count badge - Style as skeleton */}
                    <div className="absolute bottom-0.5 right-0.5 backdrop-blur-sm px-2.5 py-1 rounded-sm flex items-center gap-1 text-white z-20">
                        {/* Placeholder for count */}
                        <div className="h-3 w-4 bg-slate-800 dark:bg-pink-400/30 rounded-full" />
                        {/* Placeholder for icon */}
                        <div className="h-4 w-4 bg-slate-800 dark:bg-pink-400/30 rounded-full" />
                    </div>

                    {/* Edit button - Style as skeleton */}
                    <div className="absolute top-0.5 right-0.5 z-20 backdrop-blur-sm p-1 rounded-sm">
                        {/* Placeholder for icon */}
                        <div className="h-5 w-5 bg-slate-800 dark:bg-pink-400/30 rounded-full" />
                    </div>
                </div>
            </div>
            
            {/* Title section - Apply skeleton styles */}
            <div className="relative -mt-[1px]">
                {/* Use skeleton background */}
                <div className="bg-slate-800 dark:bg-pink-400/40 rounded-b-lg shadow-lg border-t border-slate-700/20 dark:border-pink-400/20 py-1.5 px-3">
                    {/* Placeholder for title text */}
                    <div className="h-4 w-3/4 my-1 bg-slate-700 dark:bg-pink-400/30 rounded-full" />
                </div>
            </div>
        </div>
    );
};

export default PlaylistsLoader;